import { useTranslation } from 'react-i18next';
import { MapPinIcon } from '@utils/icons';
import type { FloorVM } from '../panels/operationsPanels';
import styles from './rightRail.module.css';

export function SiteLocationMap({ floors }: { floors: FloorVM[] }) {
  const { t } = useTranslation();
  const max = Math.max(1, ...floors.map((f) => f.workers));
  return (
    <section className={styles.panel}>
      <h3 className={styles.panelTitle}>
        <span className={styles.panelTitleIcon} aria-hidden="true">
          <MapPinIcon size={14} />
        </span>
        {t('activities.panel.siteMap.title')}
      </h3>
      <div className={styles.smList}>
        {floors.map((f) => (
          <div key={f.id} className={styles.smRow}>
            <span
              className={styles.smFill}
              style={{ width: `${(f.workers / max) * 100}%` }}
              aria-hidden="true"
            />
            <span className={styles.smLabel}>{f.label}</span>
            {f.workers > 0 && (
              <span className={styles.smCount}>
                {t('activities.panel.siteMap.workers', { count: f.workers })}
              </span>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
